import corronP from "./corronP.png";
import dawhehWheP from "./dawhehWheP.png";

export const BASES_REACHES_PORTRAIT_BLOODLINES = [corronP, dawhehWheP];
